module.exports = __webpack_public_path__ + "static/media/B10.2fb07337.jpg";